const VIEW_MODE_KEY = 'viewMode';

export function getViewMode() {
    return localStorage.getItem(VIEW_MODE_KEY) || 'grid';
}

export function setViewMode(mode) {
    localStorage.setItem(VIEW_MODE_KEY, mode);
}

// Dashboard types
export const DashboardType = {
    ORGANISATION: 'organisation',
    APP: 'app',
    PANEL: 'panel'
}; 